import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import ContactForm from '../components/contactForm'

export default () => (
  <Container>
    <Row id="page-header">
      <Col>
        <h1 id="page-header-text">Contact</h1>
      </Col>
    </Row>
    <Row>
      <br></br>
      <ContactForm />
    </Row>
  </Container>
)